/* eslint-disable max-lines */
import { DSButtonV2 } from '@elliemae/ds-button-v2';
import { Grid } from '@elliemae/ds-grid';
import { styled, th } from '@elliemae/ds-system';
import { DSControlledDateTimePickerName, DSControlledDateTimePickerSlots } from '../constants/index.js';

const ResettedInput = styled('input')`
  border: none;
  box-shadow: none;
  background: none;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  :focus {
    outline: none;
  }
  :disabled {
    cursor: not-allowed;
  }
  padding-top: 2px;

  color: ${th.color('neutral-700')};

  ::placeholder {
    font-weight: ${th.fontWeight('regular')};
    color: ${th.color('neutral-500')};
  }
`;

export const StyledSeparator = styled(Grid)`
  padding-top: 2px;
  margin: auto;
  color: neutral-500;
`;

export const StyledColonSeparator = styled(Grid)`
  padding-bottom: 1px;
  margin: auto;
`;

export const Styled2DigitsInput = styled(ResettedInput)`
  width: 100%;
  height: 100%;
  ${({ disabled, theme }) => (disabled ? `color: ${theme.colors.neutral[500]};` : ``)}
`;

export const StyledDateInput = styled(Styled2DigitsInput, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.DATE_INPUTS.DAY,
})``;

export const StyledMonthInput = styled(Styled2DigitsInput, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.DATE_INPUTS.MONTH,
})``;

export const StyledYearInput = styled(Styled2DigitsInput, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.DATE_INPUTS.YEAR,
})``;

export const StyledHourInput = styled(Styled2DigitsInput, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.TIME_INPUTS.HOUR,
})``;

export const StyledMinuteInput = styled(Styled2DigitsInput, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.TIME_INPUTS.MINUTE,
})``;

export const StyledMeridiemInput = styled(Styled2DigitsInput, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.TIME_INPUTS.MERIDIEM,
})``;

export const StyledMin4DigitsInput = styled(ResettedInput)`
  width: 100%;
  height: 100%;
  ${({ disabled, theme }) => (disabled ? `color: ${theme.colors.neutral[500]};` : ``)}
`;

export const StyledInputsWrapperGrid = styled(Grid, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.CONTAINER,
})<{
  isControllerOnly: boolean;
  onlyPicker: boolean;
  hasError: boolean;
  justPicker: boolean;
  disabled: boolean;
  $readOnlyStyles?: boolean;
}>`
  width: max-content;
  align-items: center;
  background-color: white;
  ${({ isControllerOnly }) =>
    isControllerOnly
      ? ``
      : `
  height: 2.153rem;    
  border-width: 1px;
  border-style: solid;
  `}

  border-color: ${({ theme, hasError }) => {
    if (hasError) return theme.colors.danger[900];
    return theme.colors.neutral[400];
  }};

  border-radius: 2px;
  padding-left: ${({ justPicker }) => (justPicker ? '0' : '2px')};

  position: relative;
  ${({ theme, disabled }) => (disabled ? `background-color: ${theme.colors.neutral[100]};` : ``)}
  ${({ $readOnlyStyles, hasError, onlyPicker, theme }) =>
    $readOnlyStyles &&
    !hasError &&
    !onlyPicker &&
    `
    border-left: 1px solid ${theme.colors.neutral['080']};
    border-top: 1px solid ${theme.colors.neutral['080']};
    border-right: 1px solid ${theme.colors.neutral['080']};

  `}
   ${({ $readOnlyStyles, hasError, theme }) =>
     $readOnlyStyles &&
     !hasError &&
     `
    background-color: ${theme.colors.neutral['050']};
  `}
`;

export const StyledDateInputsWrapperGrid = styled.div`
  display: grid;
  grid-template-columns: 24px min-content 24px min-content 48px;
  grid-template-rows: min-content;
  padding: 6px 0;
  gap: 0px 0px;
  align-items: center;
  input,
  p {
    margin: 0;
  }
`;

export const StyledTimeInputsWrapperGrid = styled.div`
  display: grid;
  grid-template-columns: 24px min-content 24px min-content 24px min-content 24px;
  grid-template-rows: min-content;
  padding: 6px 0;
  gap: 0px 0px;
  align-items: center;
  input,
  p {
    margin: 0;
  }
`;

export const StyledPickersIconsWrapperGrid = styled(Grid)<{ isControllerOnly: boolean; hasError: boolean }>`
  position: relative;
  ${({ isControllerOnly }) => (isControllerOnly ? `` : `height: 2rem;`)}
  :before {
    content: '';
    position: absolute;
    top: 0px;
    left: -1px;
    width: 100%;
    height: 100%;
    // this shoudnt be rounded as specified in the design
    /* border-radius: 2px; */
    ${({ theme, isControllerOnly, hasError }) =>
      isControllerOnly
        ? ``
        : `
    border-left: 1px solid ${hasError ? theme.colors.danger[900] : theme.colors.neutral[400]}
    `}
  }
`;

export const StyledFocusWithIn = styled(Grid)`
  position: relative;
  &:focus-within {
    &:after {
      display: block;
      content: ' ';
      position: absolute;
      top: -5px;
      left: -2px;
      width: calc(100% + 4px);
      height: calc(100% + 10px);
      border: 2px solid ${({ theme }) => theme.colors.brand[700]};
      border-radius: 2px;
      pointer-events: none;
    }
  }
`;

export const StyledClearButton = styled(DSButtonV2, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.CLEAR_BUTTON,
})<{ shouldDisplay: boolean }>`
  height: 26px;
  position: relative;
  visibility: ${({ shouldDisplay }) => (shouldDisplay ? 'visible' : 'hidden')};
  &:focus {
    &:after {
      z-index: 1;
    }
  }
`;
